<div class="p-8 mobile:p-6">
  <div class="border-b-2 border-gray-300 pb-1">
    <p class="text-2xl font-semibold text-gray-600">SHARE ITINERARY</p>
    <mat-icon
      class="absolute top-4 right-4 text-gray-600 text-[18px] flex items-center justify-center !w-5 !h-5 rounded-full cursor-pointer"
      (click)="close()">
      close
    </mat-icon>
  </div>

  <div class="pt-6 pr-3 max-h-[60vh] overflow-auto mobile:pr-0">
    <p class="text-gray-600">Email the itinerary URL:</p>
    <ig-field label="Email addresses" icon="email" class="mt-4 block w-full" cls="w-full" [control]="form.get('emails')"
              [hint]="emailErrorMsg"></ig-field>
    <div class="flex items-center justify-between gap-2 mobile:flex-col">
      <ig-button [isAsync]="true" [disabled]="!form.valid" (trigger)="sendEmail($event)" class="mobile:w-full"
                 successText="Email sent successfully!" cls="w-[120px] mobile:w-full">
        Send
      </ig-button>
      <span class="text-sm text-blue-500 underline cursor-pointer" (click)="shareByEmailApp()" role="button">Or, open email app</span>
    </div>

    <div>
      <!--      <ig-social-share [item]="event" appearance="rounded" [showTip]="false"-->
      <!--                       (onGetLink)="showLink()"></ig-social-share>-->
      <div class="ig-share-wrap">
        <div class="mt-4 mb-2 text-gray-600 mobile:text-center">Or, share to social media</div>
        <div last class="flex gap-2 mobile:justify-center">
          <a tabindex="0" (click)="shareToFacebook()" matTooltip="Share to facebook" role="button"
             aria-label="share to facebook" class="detail-share-fb"></a>
          <a tabindex="1"
             (click)="tweetEvent()" matTooltip="Share to X" role="button"
             aria-label="share to X" class="detail-share-tweet"></a>
          <a tabindex="2" matTooltip="Get link" role="button" #matMenuTrigger
             [matMenuTriggerFor]="menu"
             class="relative w-10">
            <ig-image src="https://iti-images.s3.amazonaws.com/imgs/link.png"></ig-image>
          </a>

          <mat-menu #menu="matMenu"
                    class="ig-text-color-edit !rounded-md px-6 py-2">
            <div igClickStopPropagation>
              <p class="font-semibold text-xl !mb-2">Itinerary Link</p>

              <p>{{ link }}</p>

              <div *ngIf="!linkCopied && link.startsWith('http')" class="cursor-pointer underline text-blue-500 mt-1"
                   (click)="copy()">
                Copy to Clipboard
              </div>
              <div *ngIf="linkCopied" class="text-blue-500 mt-1">
                <mat-icon class="!h-4 !w-4 text-[16px] translate-y-0.5">check</mat-icon>
                Link Copied!
              </div>
            </div>
          </mat-menu>
        </div>
      </div>

      <div class="mt-6 pb-1">
        <p class="text-lg text-gray-600 pb-1 border-b-2 border-gray-300 font-semibold">CONTACT US</p>

        <p class="text-gray-600 !mt-1">Didn’t find everything you were looking for? Traveling with a group or need more
          information on one of the trip stops you selected? Not a problem, we’re here to help. We’re always happy to
          share tips and offer resources that can help you plan, pack and get ready to visit us.</p>

        <ig-field label="Name" icon="person" class="mt-4 block w-full" cls="w-full"
                  [control]="contactForm.get('name')" [maxlength]="100"></ig-field>
        <ig-field label="Number" icon="phone" class="block w-full" cls="w-full"
                  [control]="contactForm.get('number')" [maxlength]="20"></ig-field>
        <ig-field label="Email address*" icon="email" class="block w-full" cls="w-full"
                  [control]="contactForm.get('email')" [maxlength]="200"></ig-field>
        <ig-field label="Comment" mode="textarea" icon="title" class="block w-full" cls="w-full"
                  [control]="contactForm.get('comment')" [maxlength]="2000"></ig-field>
        <ig-button [isAsync]="true" [disabled]="!contactForm.valid" (trigger)="sendInquiry($event)"
                   class="mobile:w-full"
                   successText="Inquiry sent successfully!" cls="w-[120px] mobile:w-full">Send
        </ig-button>
        <p *ngIf="inquiryErrorMsg" class="text-sm text-red-500 !mt-2">{{ inquiryErrorMsg }}</p>

      </div>
    </div>
  </div>
</div>
